import React, { Component } from 'react';
import { NavLink } from "react-router-dom";
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import { connect } from 'react-redux';
import * as actions from '../../Actions';

import axios from 'axios';

import { persistor } from '../../Store';

import Login from './Login';

import './Header.css';


const imgLogo = require('../../assets/images/logo.svg');




let hambVisible = {
    visibility: 'visible',
};
let hambHidden = {
    visibility: 'hidden',
};


let body;
let menu;


class Header extends Component {

    state = {
        loading: false,
        secretOn: false,
        users: []
    };

    componentWillMount() {

        var field = 'cacique';
        var url = window.location.href;
        if(url.indexOf(field) != -1)
            this.setState({secretOn: true});
        return false


    }

    componentDidMount() {

        this.props.onRef(this)

        body = document.querySelector('body');
        menu = document.querySelector('.menu-icon');


        menu.addEventListener('click', () => this.toggleClass(body, 'nav-active'));


        axios
        .get('list/users')
        .then(res => this.setState({ users: res.data.users }))
        .catch(err => console.log(err))


    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    toggleClass = (element, stringClass) => {
       if(element.classList.contains(stringClass))
           element.classList.remove(stringClass);
       else
           element.classList.add(stringClass);
    }

    closeMenu = () => {
        console.log('close menu')
        document.querySelector('body').classList.remove('nav-active');
    }




    // deprecado porque ya tengo logout por url /me/logout. Igual queda el boton aca, que despues deberia ser link
    logout = () => {
        console.log('logout');

        this.props.userLogout();
        this.props.tokenRelease();
        this.props.refreshRelease();

        this.closeMenu();

        persistor.purge();
    }


    // static propTypes = {
    //     id: PropTypes.number,
    //     item: PropTypes.object,
    //     newDay: PropTypes.bool,
    //     onDelete: PropTypes.func
    // }

    render() {


        // const { newDay } = this.props;
        const { users, secretOn } = this.state;

        return (
            <div>


                <header>

                    <div className="wrapper">

                        <div className="profile">
                            <div className="logo">
                                <img src={imgLogo} alt="logo"/>
                            </div>
                            {this.props.auth.user.id ?
                                <div className="username">
                                    Hola {this.props.auth.user.name.replace(/ .*/,'')}!
                                </div>
                                :
                                <div className="slogan">
                                    el valor de<br />ser distintos.
                                </div>
                            }

                        </div>


                        <div className="menu-icon" style={this.props.auth.user.id?hambVisible:hambHidden}>
                            <span className="menu-icon__line menu-icon__line-left"></span>
                            <span className="menu-icon__line"></span>
                            <span className="menu-icon__line menu-icon__line-right"></span>
                        </div>


                    </div>

                </header>


                <div className="nav">
                    <div className="nav__content">
                        <ul className="nav__list">
                            {this.props.auth.user.id &&<li className="nav__list-item" ><NavLink activeClassName="active" to="/" onClick={this.closeMenu}>Horas</NavLink></li>}
                            {/*this.props.auth.user.id &&<li className="nav__list-item" ><NavLink activeClassName="active" to="/me/memories" onClick={this.closeMenu}>Memorias</NavLink></li>*/}
                            {/*this.props.auth.user.id &&<li className="nav__list-item" ><NavLink activeClassName="active" to="/me/notes" onClick={this.closeMenu}>Notas</NavLink></li>*/}
                            {this.props.auth.user.id &&<li className="nav__list-item" ><a onClick={this.logout} href="#">Salir</a></li>}
                        </ul>
                    </div>
                </div>




            </div>
        );

    };

}


const mapStateToProps = (state) => ({
    auth: state.auth_reducer
});

export default connect(mapStateToProps, actions)(Header);



// WEBPACK FOOTER //
// ./src/containers/Header/Header.js